import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PaymentDomainModule } from '@p2p/payment/domain';

import { PaymentApiService } from './payment-api.service';

@NgModule({
    imports: [CommonModule, PaymentDomainModule],
    providers: [PaymentApiService]
})
export class PaymentApiModule {}
